const getRestaurantFloorplanContent = () => {
  return `
    <h2 id="restaurant-floorplan">Tlocrt prostora</h2>
    <p>
      Tlocrt prostora omogućava vizualnu organizaciju stolova u restoranu ili kafiću.
      Koristite interaktivni editor za kreiranje tlocrta prema stvarnom rasporedu prostora.
    </p>

    <h3 class="mt-4">Kreiranje tlocrta</h3>
    <ol>
      <li>Idite na <strong>"Restoran" → "Tlocrt"</strong></li>
      <li>Kliknite <strong>"+ Novi tlocrt"</strong></li>
      <li>Unesite naziv (npr. "Unutarnji prostor", "Terasa")</li>
      <li>Postavite dimenzije prostora</li>
      <li>Dodajte stolove povlačenjem na tlocrt</li>
      <li>Postavite brojeve stolova</li>
      <li>Spremite tlocrt</li>
    </ol>

    <h3 class="mt-4">Dodavanje stolova</h3>
    <p>Stolovi se dodaju jednostavnim povlačenjem (drag & drop):</p>
    <ul>
      <li><strong>Okrugli stolovi</strong> - Za 2-6 osoba</li>
      <li><strong>Kvadratni stolovi</strong> - Za 4 osobe</li>
      <li><strong>Pravokutni stolovi</strong> - Za 6-8 osoba</li>
      <li><strong>Custom oblik</strong> - Prilagođeni oblici</li>
    </ul>

    <div class="success-box">
      <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Savjet:</strong> Definirajte jasne brojeve stolova koji odgovaraju stvarnom
        rasporedu u prostoru radi lake komunikacije između konobara i kuhinje.
      </div>
    </div>

    <h3 class="mt-4">Korištenje tlocrta na blagajni</h3>
    <p>Na POS sučelju, tlocrt omogućava:</p>
    <ul>
      <li>Brzo odabiranje stola za narudžbu</li>
      <li>Pregled zauzetih/slobodnih stolova</li>
      <li>Vizualan prikaz stanja narudžbi</li>
    </ul>
  `
}

const getRestaurantTablesContent = () => {
  return `
    <h2 id="tables">Rad sa stolovima</h2>
    <p>Upravljanje stolovima u restoranu ili kafiću.</p>

    <h3 class="mt-4">Tlocrt prostora</h3>
    <p>Prvo kreirajte tlocrt:</p>
    <ol>
      <li>Idite na <strong>"Restoran" → "Tlocrt"</strong></li>
      <li>Kliknite <strong>"+ Dodaj stol"</strong></li>
      <li>Odaberite tip stola (okrugli, četvrtasti, bar)</li>
      <li>Odredite broj sjedala</li>
      <li>Pozicionirajte stol na tlocrtu povlačenjem</li>
    </ol>

    <h3 class="mt-4">Statusi stola</h3>
    <ul>
      <li><span class="status-chip grey" style="color: white;">SLOBODAN</span> - Stol je prazan</li>
      <li><span class="status-chip orange" style="color: white;">ZAUZET</span> - Gosti za stolom, račun otvoren</li>
      <li><span class="status-chip red" style="color: white;">REZERVIRAN</span> - Stol rezerviran za određeno vrijeme</li>
      <li><span class="status-chip green" style="color: white;">SPREMAN ZA NAPLATU</span> - Svi artikli dostavljeni, čeka plaćanje</li>
    </ul>

    <h3 class="mt-4">Otvaranje stola</h3>
    <ol>
      <li>Na tlocrtu kliknite na stol</li>
      <li>Kliknite <strong>"Otvori stol"</strong></li>
      <li>Unesite broj gostiju (opcionalno)</li>
      <li>Dodajte artikle na račun</li>
    </ol>

    <h3 class="mt-4">Dodavanje artikala</h3>
    <p>Dok je stol otvoren:</p>
    <ul>
      <li>Pretražite ili odaberite artikl iz kategorija</li>
      <li>Unesite količinu</li>
      <li>Kliknite <strong>"Dodaj"</strong></li>
      <li>Artikl se šalje u kuhinju/bar (ako je ispis konfiguriran)</li>
    </ul>

    <h3 class="mt-4">Prebacivanje artikala između stolova</h3>
    <ol>
      <li>Kliknite na stol sa artiklima</li>
      <li>Odaberite artikle za prebacivanje</li>
      <li>Kliknite <strong>"Prebaci na drugi stol"</strong></li>
      <li>Odaberite odredišni stol</li>
    </ol>

    <h3 class="mt-4">Spajanje stolova</h3>
    <p>Ako više stolova dijeli jedno društvo:</p>
    <ol>
      <li>Odaberite prvi stol</li>
      <li>Kliknite <strong>"Spoji stolove"</strong></li>
      <li>Odaberite stolove za spajanje</li>
      <li>Svi artikli se prebacuju na glavni stol</li>
    </ol>

    <h3 class="mt-4">Zatvaranje i naplata</h3>
    <ol>
      <li>Kliknite na stol</li>
      <li>Kliknite <strong>"Zatvori stol / Naplati"</strong></li>
      <li>Odaberite način plaćanja</li>
      <li>Fiskalizirajte račun</li>
      <li>Stol postaje slobodan</li>
    </ol>

    <div class="success-box">
      <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Savjet:</strong> Koristite različite boje na tlocrtu za razlikovanje zona (terasa, unutra, VIP).
      </div>
    </div>
  `
}

const getRestaurantMenuContent = () => {
  return `
    <h2 id="restaurant-menu">Meni (Menu Items)</h2>
    <p>
      Kreiranje i organizacija menija za restoran omogućava grupisanje jela po kategorijama
      i brži pristup artiklima na POS sučelju.
    </p>

    <h3 class="mt-4">Kreiranje menija</h3>
    <ol>
      <li>Idite na <strong>"Restoran" → "Meni"</strong></li>
      <li>Kliknite <strong>"+ Novi meni"</strong></li>
      <li>Unesite naziv (npr. "Doručak", "Ručak", "Večera")</li>
      <li>Dodajte kategorije (Predjela, Glavna jela, Deserti)</li>
      <li>Dodajte artikle u svaku kategoriju</li>
      <li>Spremite meni</li>
    </ol>

    <h3 class="mt-4">Primjer strukture menija</h3>
    <ul>
      <li><strong>Predjela</strong>
        <ul>
          <li>Juha od rajčice</li>
          <li>Caesar salata</li>
          <li>Carpaccio</li>
        </ul>
      </li>
      <li><strong>Glavna jela</strong>
        <ul>
          <li>Odrezak sa prilogom</li>
          <li>Riba na gradele</li>
          <li>Vegetarijanska pizza</li>
        </ul>
      </li>
      <li><strong>Deserti</strong>
        <ul>
          <li>Tiramisu</li>
          <li>Čokoladna torta</li>
          <li>Sladoled</li>
        </ul>
      </li>
    </ul>

    <div class="info-box">
      <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Savjet:</strong> Možete kreirati različite menije za različita doba dana
        (doručak, ručak, večera) ili posebne prilike (blagdanski meni, degustacijski meni).
      </div>
    </div>

    <h3 class="mt-4">Aktiviranje menija</h3>
    <p>Na POS sučelju odaberite aktivan meni za brži pristup artiklima specifičnim za to doba dana.</p>
  `
}

const getRestaurantOrdersContent = () => {
  return `
    <h2 id="restaurant-orders">Rad sa narudžbama</h2>
    <p>
      Upravljanje narudžbama u restoranu omogućava praćenje svih aktivnih narudžbi,
      statusa pripreme i komunikaciju između konobara i kuhinje.
    </p>

    <h3 class="mt-4">Kreiranje narudžbe</h3>
    <ol>
      <li>Na POS sučelju odaberite stol iz tlocrta</li>
      <li>Dodajte artikle (jela i pića)</li>
      <li>Za svaki artikl možete dodati napomenu za kuhinju</li>
      <li>Kliknite <strong>"Pošalji u kuhinju"</strong></li>
      <li>Narudžba se automatski ispisuje na kuhinjskom pisaču</li>
    </ol>

    <h3 class="mt-4">Statusi narudžbe</h3>
    <table class="info-table">
      <thead>
        <tr>
          <th>Status</th>
          <th>Opis</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><span class="status-chip">Nova</span></td>
          <td>Narudžba je kreirana, čeka slanje u kuhinju</td>
        </tr>
        <tr>
          <td><span class="status-chip warning">U pripremi</span></td>
          <td>Kuhinja je primila narudžbu i priprema jela</td>
        </tr>
        <tr>
          <td><span class="status-chip success">Spremno</span></td>
          <td>Jela su spremna za serviranje</td>
        </tr>
        <tr>
          <td><span class="status-chip">Servirano</span></td>
          <td>Jela su serviirana gostima</td>
        </tr>
        <tr>
          <td><span class="status-chip success">Naplaćeno</span></td>
          <td>Račun je naplaćen i stol je slobodan</td>
        </tr>
      </tbody>
    </table>

    <h3 class="mt-4">Dodavanje artikala na postojeću narudžbu</h3>
    <p>Ako gost naruči dodatna jela:</p>
    <ol>
      <li>Odaberite aktivni stol</li>
      <li>Dodajte nove artikle</li>
      <li>Kliknite <strong>"Dodaj na narudžbu"</strong></li>
      <li>Novi artikli se šalju u kuhinju</li>
    </ol>

    <div class="success-box">
      <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Savjet:</strong> Koristite napomene za posebne zahtjeve gostiju
        (npr. "Bez luka", "Dobro pečeno", "Gluten free").
      </div>
    </div>

    <h3 class="mt-4">Često postavljana pitanja</h3>
    <h4 class="mt-3">Mogu li podijeliti račun po osobama?</h4>
    <p>Da, koristite opciju "Podijeli račun" i odaberite artikle za svakog gosta zasebno.</p>

    <h4 class="mt-3">Što ako se gost premjesti na drugi stol?</h4>
    <p>Koristite opciju "Premjesti narudžbu" i odaberite novi stol.</p>
  `
}

export default {
  id: 'restaurant',
  title: 'Restoran',
  icon: 'mdi-silverware-fork-knife',
  show: true,
  order: 14,
  children: [
    {
      id: 'restaurant-floorplan',
      title: 'Tlocrt prostora',
      icon: 'mdi-floor-plan',
      show: true,
      order: 1,
      content: getRestaurantFloorplanContent
    },
    {
      id: 'restaurant-tables',
      title: 'Rad sa stolovima',
      icon: 'mdi-table-furniture',
      show: true,
      order: 2,
      content: getRestaurantTablesContent
    },
    {
      id: 'restaurant-menu',
      title: 'Meni',
      icon: 'mdi-food',
      show: true,
      order: 3,
      content: getRestaurantMenuContent
    },
    {
      id: 'restaurant-orders',
      title: 'Narudžbe',
      icon: 'mdi-clipboard-list',
      show: true,
      order: 4,
      content: getRestaurantOrdersContent
    }
  ]
}
